export const meetingPrepResultKey = (roomId: string, sessionId: string) => `upcoming|${roomId}|${sessionId}`
